var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-card"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"card-description"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }